import { Record, Map as ImmutableMap, List } from 'immutable';
import * as TaskTypes from 'customer-data-objects/engagement/TaskTypes';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as TaskPriorities from 'automation-ui-action-features/actions/create-task/constants/TaskPriorities';
import OwnerAssignment from 'automation-ui-action-features/owner-assignment/OwnerAssignment';
import TimeDelay from 'automation-ui-flow-core/fields/time/TimeDelay';
import AssociationUpdate from 'automation-ui-action-features/object-type-properties/AssociationUpdate';
import findAssociationObjectTypeIdFromSpec from 'automation-ui-associations/utils/findAssociationObjectTypeIdFromSpec';
import * as CreateTaskActionMetadataKeys from 'automation-ui-action-features/actions/create-task/constants/CreateTaskActionMetadataKeys';
export const DUE_TIME_DEFAULT = new TimeDelay({
  delta: 3,
  timeOfDay: {
    hour: 8,
    minute: 0
  },
  daysOfWeek: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY']
});
export default class CreateTaskActionMetadata extends Record({
  [CreateTaskActionMetadataKeys.ACTION_TYPE]: ActionTypes.TASK,
  [CreateTaskActionMetadataKeys.BODY]: '',
  [CreateTaskActionMetadataKeys.DUE_TIME]: null,
  [CreateTaskActionMetadataKeys.OWNER_ASSIGNMENT]: null,
  [CreateTaskActionMetadataKeys.PRIORITY]: TaskPriorities.NONE,
  [CreateTaskActionMetadataKeys.REMINDER_TIME]: null,
  [CreateTaskActionMetadataKeys.SUBJECT]: null,
  [CreateTaskActionMetadataKeys.TASK_TYPE]: TaskTypes.TODO,
  [CreateTaskActionMetadataKeys.ASSOCIATIONS]: List(),
  [CreateTaskActionMetadataKeys.USE_EXPLICIT_ASSOCIATIONS]: true,
  [CreateTaskActionMetadataKeys.QUEUE_ID]: null
}, 'CreateTaskActionMetadata') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    const ownerAssignment = propMap.get(CreateTaskActionMetadataKeys.OWNER_ASSIGNMENT);
    const reminderTime = propMap.get(CreateTaskActionMetadataKeys.REMINDER_TIME);
    const dueTime = propMap.get(CreateTaskActionMetadataKeys.DUE_TIME);
    const associations = propMap.get(CreateTaskActionMetadataKeys.ASSOCIATIONS) || List();
    /**
     * NOTE: Distinguishing between null and undefined below because when dueTime is undefined we know it's a new action
     * so we can set the values to the default.
     */
    super(propMap.set(CreateTaskActionMetadataKeys.OWNER_ASSIGNMENT, new OwnerAssignment(ownerAssignment || {})).set(CreateTaskActionMetadataKeys.REMINDER_TIME, reminderTime ? new TimeDelay(reminderTime) : null).set(CreateTaskActionMetadataKeys.DUE_TIME, dueTime !== null ? new TimeDelay(dueTime || DUE_TIME_DEFAULT) : null).set(CreateTaskActionMetadataKeys.ASSOCIATIONS, List(associations.map(assoc => new AssociationUpdate(assoc)))));
  }
  getAssociations() {
    return this.get(CreateTaskActionMetadataKeys.ASSOCIATIONS);
  }
  addAssociation(newAssociation) {
    return this.update('associations', associations => associations.push(newAssociation || new AssociationUpdate({
      targetSpec: undefined,
      value: {
        type: 'COPY_ASSOCIATION'
      }
    })));
  }
  deleteAssociation(index) {
    return this.update('associations', associations => associations.delete(index));
  }
  setAssociation(index, newAssociation) {
    return this.update('associations', associations => associations.set(index, newAssociation));
  }
  setAssociations(associations) {
    return this.set(CreateTaskActionMetadataKeys.ASSOCIATIONS, associations);
  }
  getAssociationsAsObjectList(associationDefinitionsQuery) {
    const associations = this[CreateTaskActionMetadataKeys.ASSOCIATIONS];
    return associations.filter(association => !association.isEnrolledObjectAssociation()).map(association => findAssociationObjectTypeIdFromSpec(association.getTargetSpec(), associationDefinitionsQuery)).filter(association => !!association).toJS();
  }
  getSubject() {
    return this[CreateTaskActionMetadataKeys.SUBJECT];
  }
  hasDuplicateAssociations() {
    const associations = this.associations;
    const uniqueAssociations = associations.map(association => {
      var _association$value$so, _association$targetSp;
      return `source-${(_association$value$so = association.value.sourceSpec) === null || _association$value$so === void 0 ? void 0 : _association$value$so.getFullAssociationTypeId()}-target-${(_association$targetSp = association.targetSpec) === null || _association$targetSp === void 0 ? void 0 : _association$targetSp.getFullAssociationTypeId()}`;
    }).toSet();
    return uniqueAssociations.size !== associations.size;
  }
}